import React from "react";
import classes from "./AIPanelContent.scss";

/**
 * @description
 * AIPanelContent Component
 */
const AIPanelContent = props => {
  // const { testId } = props;

  return <div className={classes.aIPanelContent}>Content</div>;
};

export default AIPanelContent;
